module.exports = __webpack_public_path__ + "static/service3-7c1550dc325a325c9d025e4e21c1b6c8.png";